import React, { useState } from 'react';
import TopBar from './TopBar/TopBar';
import './DashboardPagesLayout.css';

type Props = {
  children: React.ReactNode;
  leftComponentTitle?: string | React.ReactNode;
};

const DashboardPagesLayout = ({ children, leftComponentTitle }: Props) => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setMenuOpen(!isMenuOpen);
  };

  return (
    <div className={`dashboard-layout ${isMenuOpen ? 'menu-open' : ''}`}>
      <div className="dashboard-main">
        <TopBar
          leftComponentTitle={leftComponentTitle}
          onMenuToggle={handleMenuToggle}
        />
        <main className="dashboard-content">{children}</main>
      </div>
    </div>
  );
};

export default DashboardPagesLayout;
